import { AgendaItemViewModel } from '../../../../../../components/DailyAgenda/viewModel/agendaViewModel/agendaViewModel';

export type AgendaItemLayoutProps = {
  agendaItemViewModel: AgendaItemViewModel;
  onSlotClick: (slotId: string) => Promise<void>;
  onReadMoreClick?: (slotId: string) => Promise<void>;
};

/**
 * The dot between the staff member and the location on a course row. Only a
 * separator, so a screen reader skips it and reads the two names on their own.
 */
export const STAFF_LOCATION_SEPARATOR_DATA_HOOK =
  'agenda-item-staff-location-separator';
